import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

/** B32108 — Confirmation of Registrable Controllers (declaration summary) */
const confirmationControllersDetailMap = {
  title: 'Confirmation of Registrable Controllers',
  fields: [
    { label: 'Company', key: ['company_name', 'companyName'] },
    { label: 'UEN', key: ['company_registration_no', 'companyRegistrationNo'] },
    { label: 'Confirmation date', key: ['confirmation_date', 'confirmationDate'] },
    {
      label: 'Controllers confirmed',
      key: ['controllers_list', 'controllers'],
      format: (raw: unknown) => {
        const arr = Array.isArray(raw) ? raw : [];
        if (!arr.length) return '';
        const names = arr
          .map((r: Record<string, unknown>) => String(r.controller_name ?? r.full_name ?? '').trim())
          .filter(Boolean);
        return names.length ? `${names.length}: ${names.join('; ')}` : String(arr.length);
      },
    },
  ],
};

registerRegisterDetail('B32108', confirmationControllersDetailMap);
